import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { CompactHeader } from "../../landing/components/CompactHeader";
import { Footer } from "../../landing/components/Footer";
import BackLoader from "../../components/backloader";
import "./hctc.css";

// Public page opened from the QR code on a certified true copy (no login).
export default function VerifyCertified() {
  const { code } = useParams();
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const resp = await fetch(`${Constants.apiUrl}/serviceapp/verify/${encodeURIComponent(code)}`);
        setD(await resp.json());
      } catch (e) {
        setD({ code: -999, status: "The verification service is not reachable right now." });
      }
      setLoading(false);
    })();
  }, [code]);

  const ok = d?.code === 0 && d.valid;
  const date = (v) => (v ? Constants.momentDate(v).format("DD MMMM YYYY") : "-");

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <CompactHeader />
      <div className="hctc-page" style={{ maxWidth: 820, margin: "40px auto" }}>
        <h2>Certified True Copy Verification</h2>
        <div className="hctc-sub">Verification number: {code}</div>
        {d && d.code !== 0 && <div className="hctc-err">{d.status || "No certified document matches this verification number."}</div>}
        {d?.code === 0 && (
          <div className="hctc-card">
            <div className={ok ? "hctc-ok" : "hctc-warn"} style={{ fontSize: 15, fontWeight: 600 }}>
              {ok ? "This is a genuine certified true copy issued by the High Court of Lagos State." : "This certification is not active."}
            </div>
            <div className="hctc-kv" style={{ marginTop: 10 }}>
              <div className="k">Service</div>
              <div className="v">{d.service}</div>
              <div className="k">Application number</div>
              <div className="v">{d.applicationNumber}</div>
              <div className="k">Case number</div>
              <div className="v">{d.caseNumber || "-"}</div>
              {d.legacyCaseNumber && (
                <>
                  <div className="k">Legacy case number</div>
                  <div className="v">{d.legacyCaseNumber}</div>
                </>
              )}
              <div className="k">Case title</div>
              <div className="v">{d.caseTitle || "-"}</div>
              <div className="k">Classification</div>
              <div className="v">{d.classification}</div>
              {d.originalFilingDate && (
                <>
                  <div className="k">Original filing date</div>
                  <div className="v">{date(d.originalFilingDate)}</div>
                </>
              )}
              <div className="k">Certified on</div>
              <div className="v">{date(d.certifiedOn)}</div>
              <div className="k">Certified by</div>
              <div className="v">{d.certifiedBy || "-"}</div>
            </div>
            <h4 style={{ marginTop: 16 }}>Certified documents</h4>
            <table className="case-table">
              <thead>
                <tr>
                  <th>Document</th>
                  <th>Pages</th>
                  <th>Fingerprint (SHA-256)</th>
                </tr>
              </thead>
              <tbody>
                {(d.documents || []).map((x, i) => (
                  <tr key={i}>
                    <td>{x.title}</td>
                    <td>{x.pageCount}</td>
                    <td style={{ fontSize: 11, wordBreak: "break-all" }}>{x.fileHash}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="hctc-muted" style={{ marginTop: 8 }}>
              Compare the page count and stamp on your copy with this record. Any difference means the document may have been altered.
            </div>
          </div>
        )}
      </div>
      <Footer />
      <BackLoader open={loading} />
    </div>
  );
}
